import gql from 'graphql-tag';

import type { AllInstructionsData } from 'src/data/generation';
import { executeGqlMutation } from 'src/graphql/client';
import type { ID } from 'src/lib/collection';
import { getSingleProp } from 'src/lib/graphql';
import type { Override } from 'src/lib/types';
import type { BackendMutationUpdateCopilotDefaultsArgs } from 'src/types/backend';

const MUTATION = gql`
  mutation UpdateCopilotDefaults(
    $customerId: ID!
    $workspaceId: ID!
    $tov: JSON
    $sfv: JSON
    $improveKeepStructure: Boolean
  ) {
    updateCopilotDefaults(
      customerId: $customerId
      workspaceId: $workspaceId
      tov: $tov
      sfv: $sfv
      improveKeepStructure: $improveKeepStructure
    ) {
      settings {
        copilotCustomerId
        copilotWorkspaceId
        copilotTov
        copilotSfv
        copilotImproveKeepStructure
      }
    }
  }
`;

interface CopilotDefaultsResult {
  settings: {
    copilotCustomerId?: ID;
    copilotWorkspaceId?: ID;
    copilotTov?: ID;
    copilotSfv?: AllInstructionsData | null;
    copilotImproveKeepStructure?: boolean;
  };
}

type Variables = Override<
  BackendMutationUpdateCopilotDefaultsArgs,
  {
    tov?: { defaultPreset: string } | { customId: ID } | null;
    sfv?: AllInstructionsData | null;
  }
>;

export const updateCopilotDefaults = async ({
  customerId,
  workspaceId,
  tov,
  sfv,
  improveKeepStructure,
}: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables: {
      customerId,
      workspaceId,
      tov: tov ?? null,
      sfv: sfv ?? null,
      improveKeepStructure: improveKeepStructure ?? null,
    },
  });

  return getSingleProp<CopilotDefaultsResult>(result.data);
};
